// constants
import { DepartmentActionTypes } from './constants';
import { Department as DepartmentData } from 'src/types/department';

export type DepartmentActionType = {
    type:
        | DepartmentActionTypes.API_RESPONSE_SUCCESS
        | DepartmentActionTypes.API_RESPONSE_ERROR
        | DepartmentActionTypes.GET_DEPARTMENT
        | DepartmentActionTypes.RESET
        | DepartmentActionTypes.RESET_SUCCESS
        | DepartmentActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const departmentApiResponseSuccess = (
    actionType: string,
    data: DepartmentData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): DepartmentActionType => ({
    type: DepartmentActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const departmentApiResponseError = (
    actionType: string,
    data: DepartmentData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): DepartmentActionType => ({
    type: DepartmentActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const GetDepartment = (params: any): DepartmentActionType => ({
    type: DepartmentActionTypes.GET_DEPARTMENT,
    payload: params,
});

export const resetDepartment = (): DepartmentActionType => ({
    type: DepartmentActionTypes.RESET,
    payload: {},
});

export const resetDepartmentSuccess = (): DepartmentActionType => ({
    type: DepartmentActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetDepartmentError = (): DepartmentActionType => ({
    type: DepartmentActionTypes.RESET_ERROR,
    payload: {},
});
